import fetcher from 'api/fetcher';
import { BannerImageCropType } from 'utils/constants/banner';

import { AppThunkAction } from 'store/utils';

interface CropInfo {
    originalImageId: number;
    x: number;
    y: number;
    imageWidth: number;
    imageHeight: number;
    cropType: BannerImageCropType;
}

type Crop = (activeCropTypes: BannerImageCropType[]) => AppThunkAction;

type GetAbsValue = (dimension: number, percent: number) => number;

const getAbsValue: GetAbsValue = (dimension, percent) => Math.trunc((percent * dimension) / 100);

export const saveCrops: Crop = (activeCropTypes) => {
    return (_, getState) => {
        const { images } = getState().createBanner;
        const body: CropInfo[] = [];
        activeCropTypes.forEach((cropType) => {
            const { id, width, height } = images[cropType];
            const { percentCrop } = images[cropType].cropInfo || {};
            if (percentCrop?.width && width && height && id) {
                const percentCropX = percentCrop.x > 0 ? percentCrop.x : 0;
                const percentCropY = percentCrop.y > 0 ? percentCrop.y : 0;
                body.push({
                    originalImageId: id,
                    x: getAbsValue(width, percentCropX),
                    y: getAbsValue(height, percentCropY),
                    imageWidth: getAbsValue(width, percentCrop.width),
                    imageHeight: getAbsValue(height, percentCrop.height),
                    cropType,
                });
            }
        });
        return fetcher.post('/api/v1/images/crop', body);
    };
};
